const colors = {
  primary: [
    '#007681',
    '#80B9BE',
    '#C2DBDE',
    '#1c71cb',
    '#c2e2fb',
    '#B9D7F0',
    '#DCEDF6'
  ],
  secondary: [
    '#FFB500',
    '#FFD987',
    '#FFECC3',
    '#f8bbd0'
  ],
  danger: [
    '#D95450',
    '#EB3620',
    '#cb4647',
    '#FCD0C2',
    '#FFEAE3',
    '#FEEAE4'
  ],
  alert: [
    '#FC7C26',
    '#ec8924',
    '#ffa000',
    '#ffc107',
    '#ffd761',
    '#ffecb3'
  ],
  success: [
    '#22b884',
    '#4caf50',
    '#7cc47f',
    '#c8e6c9'
  ],
  white: [
    '#fff',
    '#fff',
    '#eee'
  ],
  grayscale: [
    '#212121',
    '#3F4040',
    '#616161',
    '#9e9e9e',
    '#bdbdbd',
    '#cdcdcd',
    '#e0e0e0',
    '#FAFBFE',
    '#ffffff',
  ],
}

const theme = {
  button: {
    backgroundColor: '#2c53a7',
    borderColor: '#6383c1',
    loader: '#fff',
    disabled: '#e6e9ec',
    secondary: '#DBDDDE',
  },
  footer: {
    backgroundColor: '#e8e8e8',
  },
  header: {
    borderColor: colors.secondary[0],
    backgroundColor: '#fff',
    color: colors.grayscale[5],
    title: colors.grayscale[2],
    normalBorder: '#BBBBBB',
  },
  input: {
    iconColor: '#ccc',
    invalid: '#dc3545',
  },
  link: {
    color: colors.primary[3],
  },
  badge: {
    backgroundColor: '#649DFB',
  },
};

theme.palette = {
  ...colors,
  env: {
    development: { color: 'black' , backgroundColor: '#4caf50'},
    QA: { color: '#000' , backgroundColor: '#FEFF00'},
    staging: { color: '#fff' , backgroundColor: '#0F02FF'}
  }
};

theme.fonts = {
  primary: 'Open Sans, sans-serif',
  pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
  quote: 'Georgia, serif',
  weight: {
    light: 300,
    normal: 400,
    bold: 600,
  },
};

theme.sizes = {
  normal: '1rem',
  small: '0.8rem',
  large: '2rem',
  maxWidth: '900px',
};

export default theme;
